import { render, staticRenderFns } from "./LefSecondaryNavigation.vue?vue&type=template&id=cb3dc3aa&scoped=true"
import script from "./LefSecondaryNavigation.vue?vue&type=script&lang=js"
export * from "./LefSecondaryNavigation.vue?vue&type=script&lang=js"
import style0 from "./LefSecondaryNavigation.vue?vue&type=style&index=0&id=cb3dc3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3dc3aa",
  null
  
)

export default component.exports